var scope_0 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/185fb23cb9561baabc79b60f643478fe.js').default;
var scope_1 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/68f016b926ce6678a103af39d7cf8b3d.js').default;
var scope_2 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82b2e35d2e2dd8f4bbf99733ca839b48.js').default;
var scope_3 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d1b8bf5402e366daaab54c0ed612f552.js').default;
var scope_4 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d1fe18ea29fdf7595ad8158670348bb8.js').default;
var scope_5 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7c14701ffe1512bdb6b40404f0874ad.js').default;
var scope_6 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e41b2c28a23afdb83e017d380f395c39.js').default;
var scope_7 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_8 = require('/Users/ashk/Desktop/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f156cc9329c12284340267003818f4a6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    